import { useField } from 'formik';
import { PropsWithChildren } from 'react';

import { useCurrentUser } from '@/react/hooks/useUser';
import { EnvironmentGroupId } from '@/react/portainer/environments/types';

import { TagSelector } from '@@/TagSelector';
import { FormSection } from '@@/form-components/FormSection';

import { GroupField } from './GroupsField';
import { GroupInheritance } from './GroupInheritance';

interface Props {
  /** Lists what environments in the selected group inherit from it */
  showGroupInheritance?: boolean;
}

export function MetadataFieldset({
  children,
  showGroupInheritance = false,
}: PropsWithChildren<Props>) {
  const [tagProps, , tagHelpers] = useField('meta.tagIds');
  const [{ value: groupId }] = useField<EnvironmentGroupId>('meta.groupId');

  const { isPureAdmin } = useCurrentUser();

  return (
    <FormSection title="Metadata">
      {children}

      <GroupField allowCreate={isPureAdmin} />

      {showGroupInheritance && <GroupInheritance groupId={groupId} />}

      <TagSelector
        value={tagProps.value}
        allowCreate={isPureAdmin}
        onChange={(value) => tagHelpers.setValue(value)}
      />
    </FormSection>
  );
}
